import { render } from "./GuiRoleMultiSelect.vue?vue&type=template&id=1be6ec08"
import script from "./GuiRoleMultiSelect.vue?vue&type=script&lang=js"
export * from "./GuiRoleMultiSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__